module.exports = __webpack_public_path__ + "static/screenshot-steele-meals-4b9068761f063473035b603279fa44a2.png";